import { Observable, BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RechargeSansInscriptionService {

  public rechargeUrl = "https://recharge.clem.mobi";
  public statUrl = "https://api-oauth.clem.mobi";
  public stripeUrl = "https://stripe.clem.mobi";
  public financialUrl = "https://financial.clem.mobi";
  



  constructor(private http: HttpClient, private cookieService: CookieService) { }





  // shared service  card 
  private recharge_info = new BehaviorSubject<any>(null);
  currentrecharge_info = this.recharge_info.asObservable();

  changeRechargeInfo(message: any) {
    this.recharge_info.next(message)
  }






  getStationRechargeSansInscription(guid: string): Observable<any> {

  let tokenString = localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.get<any>(`${this.rechargeUrl}/api/station/${guid}`, httpOptions);
 }




 postUserRecharge(body): Observable<any> {

  let tokenString = localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.post<any>(`${this.rechargeUrl}/api/users`, body, httpOptions);
 }


 postBookRecharge(access_token, stationId): Observable<any> {

 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +access_token)}
             
   return this.http.post<any>(`${this.rechargeUrl}/api/book/qr`, stationId, httpOptions);
 }



 postPinBookRecharge(body): Observable<any> {

  let tokenString = localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.post<any>(`${this.rechargeUrl}/api/book/authorise`, body, httpOptions);
 }


 postRemoteRecharge(body): Observable<any> {

  let tokenString = localStorage.getItem('token_offline')
  let token =  JSON.parse(tokenString)  
 
         let httpOptions = {
           headers: new HttpHeaders()
             .set('Authorization', 'Bearer ' +token.access_token)}
             
   return this.http.post<any>(`${this.rechargeUrl}/api/book/remote`, body, httpOptions);
 }


   // send card
   sendCard(card: any, userId: any, url: any): Observable<any> {

     let returnurl = `http://${url}/payment/confirm`
     console.log(returnurl)

    const params = new HttpParams()
      .set('driver', userId )
      .set('cbnum', card.numberCard )
      .set('cbcvc', card.cvc )
      .set('cbmonth', card.month )
      .set('cbyear', card.year )
      .set('network', card.network )
      .set('returnurl', returnurl )

    return this.http.get<any>(`${this.stripeUrl}/api/v1/Clem/OneShotPayment`, { params: params });
  }



   // send card
   send3Dsecure(name: any): Observable<any> {

    const params = new HttpParams()
      .set('object', 'paymentIntents')
      .set('name', name);

    return this.http.get<any>(`${this.stripeUrl}/api/v1/Stripe/getStripeObject`, { params: params });
  }





     // send card
     updateDriver(name: any, idPayment:any): Observable<any> {

      const params = new HttpParams()
        .set('driver', name)
        .set('id', idPayment);
      return this.http.get<any>(`${this.stripeUrl}/api/v1/Clem/UpdatePrepayment`, { params: params });
    }


     // get card type 
    getCardType(number: any): Observable<any> {

      // let returnurl = 'https://subscribe.clem.mobi/payment-clem/confirm'
      // let returnurl = 'http://localhost:4200/payment-clem/confirm'
  
      // const params = new HttpParams()
      //   .set('token', '639031af300865b472e28e7043e32c09')
      //   .set('request', JSON.stringify({ "task": "Register3DSCard", "id": loginCard, "returnurl": returnurl, "card": data }));
  
      return this.http.get<any>(`${this.financialUrl}/stripeclemapi/public/index.php/api/v1/Stripe/getCardNetworks?number=${number}`);
    }
  
}
